import React from 'react';
import MicroApp from '@/components/micro-app';
import { data as dataJump } from '@/pages/activity-manage/merchants/venue-detail/constants/index';

import env from '@/env';

function UserSetting(props: any) {
  const { data, pathInUserSetting = '', ..._props } = props;

  return (
    <MicroApp
      data={{ ...data, jumpUserSetting: dataJump.jumpUserSetting }}
      {..._props}
      destory
      name="tbusersetting"
      url={`${env.MC_DOMAIN}/dist/pages/userSetting` + pathInUserSetting}
    />
  );
}

export default UserSetting;
